import React from 'react'
import { AppRoutes } from '@core/AppRoutes'
import { appHistory } from '@core/Utils/routing/history'

export const useAutoOptinListener = (shouldAutoOptIn: boolean, mutateFn: () => void) => {
  React.useEffect(() => {
    if (shouldAutoOptIn) {
      mutateFn()
      appHistory.replace(AppRoutes.MarketingCommunications)
    }
  }, [mutateFn, shouldAutoOptIn])
}
